import { chakra, Flex } from '@stockx/ui';
import COLLAGE_HEIGHT from './consts';

export const CollageBannersWrapper = chakra(Flex, {
  baseStyle: {
    justifyContent: 'space-between',
    maxH: COLLAGE_HEIGHT,
    width: '100%',
  },
});
